(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-nav"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    const categoryScroll = document.getElementById('category-scroll')

    function updateJustification() {
      const hasOverflow = categoryScroll.scrollWidth > categoryScroll.clientWidth

      if (hasOverflow) {
        categoryScroll.classList.remove('justify-center')
        categoryScroll.classList.add('justify-start')
      } else {
        categoryScroll.classList.remove('justify-start')
        categoryScroll.classList.add('justify-center')
      }
    }

    updateJustification()
    window.addEventListener('resize', updateJustification)
    categoryScroll.addEventListener('load', updateJustification)
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.accordion-toggle').forEach((button) => {
      button.addEventListener('click', function () {
        const contentDiv = this.nextElementSibling
        const isOpen = contentDiv.getAttribute('data-state') === 'open'
        const plus = this.querySelector('.plus')
        const minus = this.querySelector('.minus')

        if (isOpen) {
          contentDiv.setAttribute('data-state', 'closed')
          contentDiv.style.maxHeight = '0'
          plus.classList.remove('hidden')
          minus.classList.add('hidden')
        } else {
          contentDiv.setAttribute('data-state', 'open')
          contentDiv.style.maxHeight = contentDiv.scrollHeight + 'px'
          plus.classList.add('hidden')
          minus.classList.remove('hidden')
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sales"] && !Shopify.designMode) return;
  try {
    
  function initCountdown() {
    const containers = document.querySelectorAll('[data-end-year]')
    if (containers.length === 0) return

    containers.forEach((container) => {
      const year = parseInt(container.getAttribute('data-end-year')) || 2025
      const month = parseInt(container.getAttribute('data-end-month')) || 1
      const day = parseInt(container.getAttribute('data-end-day')) || 1
      const hour = parseInt(container.getAttribute('data-end-hour')) || 0
      const minute = parseInt(container.getAttribute('data-end-minute')) || 0

      const endDate = new Date(year, month - 1, day, hour, minute, 0)

      try {
        if (isNaN(endDate.getTime())) {
          console.error('Fecha inválida:', { year, month, day, hour, minute })
          return
        }

        function updateCountdown() {
          const now = new Date().getTime()
          const distance = endDate.getTime() - now

          if (distance < 0) {
            container.querySelectorAll('[data-value]').forEach((el) => (el.textContent = '00'))
            return
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24))
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
          const seconds = Math.floor((distance % (1000 * 60)) / 1000)

          const daysEl = container.querySelector('[data-value="days"]')
          const hoursEl = container.querySelector('[data-value="hours"]')
          const minutesEl = container.querySelector('[data-value="minutes"]')
          const secondsEl = container.querySelector('[data-value="seconds"]')

          if (daysEl) daysEl.textContent = String(days).padStart(2, '0')
          if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0')
          if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0')
          if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0')
        }

        updateCountdown()
        setInterval(updateCountdown, 1000)
      } catch (error) {
        console.error('Error al procesar fecha:', error)
      }
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdown)
  } else {
    initCountdown()
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  if (!window.instagramScriptLoaded) {
    const script = document.createElement('script')
    script.src = '//www.instagram.com/embed.js'
    script.async = true
    document.body.appendChild(script)
    window.instagramScriptLoaded = true
  } else if (window.instgrm) {
    window.instgrm.Embeds.process()
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banners"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    if (typeof window === 'undefined') return
    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0

    var tracks = document.querySelectorAll('.js-drag-scroll')
    tracks.forEach(function (el) {
      var isDown = false
      var startX
      var scrollLeft
      var moved = false

      el.addEventListener('mousedown', function (e) {
        isDown = true
        el.classList.add('dragging')
        startX = e.pageX - el.offsetLeft
        scrollLeft = el.scrollLeft
        moved = false
        e.preventDefault()
      })

      el.addEventListener('mousemove', function (e) {
        if (!isDown) return
        var x = e.pageX - el.offsetLeft
        var walk = x - startX
        if (Math.abs(walk) > 3) moved = true
        el.scrollLeft = scrollLeft - walk
      })
      ;['mouseup', 'mouseleave'].forEach(function (ev) {
        el.addEventListener(ev, function () {
          isDown = false
          el.classList.remove('dragging')
        })
      })

      el.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.preventDefault()
            e.stopPropagation()
          }
        },
        true
      )
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
